import { createTheme } from '@mui/material/styles';
import { MuiAlert, MuiButton, MuiButtonBase, MuiCheckbox, MuiCircularProgress, MuiDialog, MuiFab, MuiMenu, MuiMenuItem, MuiRadio, MuiSvgIcon, MuiTabs, typography } from './overrides';
import { light, dark } from './variants';
export const theme = (mode) => {
    if (mode !== 'light' && mode !== 'dark') {
        throw new Error(`Theme ${mode} not supported`);
    }
    const baseTheme = mode === 'light' ? light : dark;
    return createTheme(baseTheme, {
        typography,
        components: {
            MuiAlert: MuiAlert(),
            MuiButtonBase: MuiButtonBase(baseTheme),
            MuiButton: MuiButton(baseTheme),
            MuiCheckbox: MuiCheckbox(baseTheme),
            MuiCircularProgress: MuiCircularProgress(),
            MuiDialog: MuiDialog(),
            MuiFab: MuiFab(baseTheme),
            MuiRadio: MuiRadio(baseTheme),
            MuiSvgIcon: MuiSvgIcon(),
            MuiMenu: MuiMenu(),
            MuiMenuItem: MuiMenuItem(baseTheme),
            MuiTabs: MuiTabs(baseTheme)
        }
    });
};
